import { useEffect, useMemo, useState } from "react";
import NavbarIn from "../../shared/navbar-in";
import jwtDecode from "jwt-decode";
import SpinnerComponent from "../../shared/spinner";
import { fetchDataMenu } from "../../shared/functions";
import { Accordion } from "react-bootstrap";

const GROUP_ICONS = {
  Auditoría: "🔍",
  Calidad: "✅",
  Comercial: "💼",
  Despachos: "🚚",
  Financiera: "💰",
  Mantenimiento: "🔧",
  Producción: "🏭",
  Sistemas: "💻",
  SST: "🦺",
  "Talento Humano": "👥",
  Técnica: "📐",
  Transporte: "🚌",
  Contabilidad: "📊",
};

function AreaItem({ area }) {
  const hasUrl = !!area.areaUrl;
  const hasDescription = !!area.areaDescription?.trim();

  const content = (
    <div
      className="d-flex align-items-center justify-content-between gap-3 rounded-4 px-3 px-md-4 py-3"
      style={{
        backgroundColor: "rgba(255,255,255,0.03)",
        border: "1px solid rgba(255,255,255,0.06)",
        opacity: hasUrl ? 1 : 0.55,
        transition: "all 0.2s ease",
      }}
      title={hasDescription ? area.areaDescription : ""}
    >
      <div className="d-flex flex-column">
        <span
          style={{
            fontSize: "0.95rem",
            fontWeight: 500,
            color: hasUrl ? "#f8f9fa" : "rgba(255,255,255,0.60)",
            lineHeight: "1.35",
          }}
        >
          {area.areaName}
        </span>
      </div>

      {hasUrl && (
        <span
          style={{
            color: "rgba(255,255,255,0.55)",
            fontSize: "0.95rem",
            flexShrink: 0,
          }}
        >
          ↗
        </span>
      )}
    </div>
  );

  if (!hasUrl) return content;

  return (
    <a
      href={area.areaUrl}
      target="_self"
      rel="noopener noreferrer"
      style={{ textDecoration: "none" }}
    >
      {content}
    </a>
  );
}

function DashboardMenu({ data = [] }) {
  const grouped = useMemo(() => {
    return data.reduce((acc, area) => {
      if (!acc[area.areaGroup]) acc[area.areaGroup] = [];
      acc[area.areaGroup].push(area);
      return acc;
    }, {});
  }, [data]);

  const groups = Object.keys(grouped).sort();

  if (!data.length) {
    return (
      <div
        className="rounded-4 p-2 text-center"
        style={{
          backgroundColor: "rgba(255,255,255,0.04)",
          border: "1px solid rgba(255,255,255,0.08)",
          color: "rgba(255,255,255,0.7)",
        }}
      >
        No hay módulos disponibles para mostrar.
      </div>
    );
  }

  return (
    <Accordion className="row g-3 g-lg-2">
      {groups.map((group, index) => {
        const areas = grouped[group];
        const icon = GROUP_ICONS[group] || "📁";
        const availableCount = areas.filter((a) => a.areaUrl).length;

        return (
          <div key={group} className="col-12 col-md-6 col-xl-4">
            <Accordion.Item
              eventKey={String(index)}
              className="rounded-4 overflow-hidden h-100"
              style={{
                backgroundColor: "rgba(255,255,255,0.05)",
                border: "1px solid rgba(255,255,255,0.10)",
                boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
              }}
            >
              <Accordion.Header>
                <div className="d-flex align-items-center justify-content-between w-100 pe-2 gap-3">
                  <div className="d-flex align-items-center gap-2">
                    <span style={{ fontSize: "1.05rem" }}>{icon}</span>
                    <span
                      style={{
                        fontSize: "0.98rem",
                        fontWeight: 600,
                        color: "#081224",
                      }}
                    >
                      {group}
                    </span>
                  </div>

                  <span
                    className="rounded-pill px-2 py-1"
                    style={{
                      fontSize: "0.75rem",
                      color: "#081224",
                      backgroundColor: "rgba(8,18,36,0.08)",
                      border: "1px solid rgba(8,18,36,0.10)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {availableCount}/{areas.length}
                  </span>
                </div>
              </Accordion.Header>

              <Accordion.Body
                style={{
                  backgroundColor: "rgba(255,255,255,0.02)",
                  borderTop: "1px solid rgba(255,255,255,0.08)",
                }}
              >
                <div className="d-flex flex-column gap-2">
                  {areas.map((area) => (
                    <AreaItem key={area.id} area={area} />
                  ))}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </div>
        );
      })}
    </Accordion>
  );
}

export default function Admin() {
  const token = localStorage.getItem("token");
  const payload = jwtDecode(token);
  const { userName } = payload;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const data = await fetchDataMenu({ userName, token });
        setData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [token, userName]);

  if (loading) {
    return <SpinnerComponent />;
  }

  return (
    <div
      className="min-vh-100"
      style={{
        background: "linear-gradient(180deg, #050b18 0%, #081224 100%)",
      }}
    >
      <NavbarIn />

      <div className="container py-2 py-lg-4">
        <div className="mb-1 mb-lg-5">
          <div
            className="d-inline-flex align-items-center gap-2 rounded-pill px-3 py-2 mb-3"
            style={{
              backgroundColor: "rgba(255,255,255,0.05)",
              border: "1px solid rgba(255,255,255,0.10)",
              fontSize: "0.82rem",
              color: "rgba(255,255,255,0.75)",
            }}
          >
            <button
              type="button"
              className="btn btn-sm"
              onClick={() =>
                window.open(
                  `http://138.121.202.135:9090/plantas/bridge/test-login.php?u=${userName}`,
                  "_blank",
                  "noopener,noreferrer",
                )
              }
              style={{
                backgroundColor: "#1450ff",
                color: "#ffffff",
                border: "1px solid rgba(255,255,255,0.12)",
                borderRadius: "999px",
                padding: "0.45rem 0.9rem",
                fontSize: "0.82rem",
                fontWeight: 600,
                letterSpacing: "0.02em",
                boxShadow: "0 8px 20px rgba(20,80,255,0.22)",
              }}
            >
              IR A LA EXTRANET
            </button>
            <span>Acceso directo a la extranet de plantas.</span>
          </div>
        </div>

        <DashboardMenu data={data} />
      </div>
    </div>
  );
}
